// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterTOTP-Divider_cls1__RmwLN","cls2":"InviteRegisterTOTP-Divider_cls2__iYU2v InviteRegisterTOTP-Divider_cls1__RmwLN"};